export default {
  DetailByObject: 1, // Chi tiết theo đối tượng
  DetailByObjectDecision: 2, // Chi tiết theo đối tượng và quyết định
  NotDetail: 0, // Không chi tiết
  DetailByBank: 3, // Chi tiết theo ngân hàng
};